module.exports = __webpack_public_path__ + "img/修改昵称.225c6b1e.png";